import styled from "styled-components";

export const FormContainer = styled.div`
  font-family: "Nunito";
`;

export const Container = styled.div`
  background-color: #f8f8f8;
  padding: 20px;
  width: 100%;
`;

export const GridGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`;

export const GridGroup3 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
`;
